import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProductCardB } from "./ProductCardB";
import colorSharp2 from "../../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { basicPacksLinks } from "./basicPacksLinks";
import { standardPacksLinks } from "./standardPacksLinks";
import { premiumPacksLinks } from "./premiumPacksLinks";

export const Products = () => {

  
  return (
    <section className="productPrinting" id="products">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Products</h2>
                <p>At TotleSoft, we offer products/bundles for Wedding, Burial, Birthday, Company, Small/Large Businesses, Organizations, Government and Individual. <span className="chris">Take a glance at some of our packages below and place your order by clicking the SEE PRICE / ORDER NOW link:</span></p>
                <p className='onlyMobile'>Tap the Basic, Standard or Premium button to learn more</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Basic</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Standard</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Premium</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          basicPacksLinks.map((basicPacksLink, index) => {
                            return (
                              <ProductCardB
                                key={index}
                                {...basicPacksLink}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>

                    <Tab.Pane eventKey="second">
                    <Row>
                      {
                          standardPacksLinks.map((standardPacksLink, index) => {
                            return (
                              <ProductCardB
                                key={index}
                                {...standardPacksLink}
                                />
                            )
                          })
                        } 
                    </Row>
                    </Tab.Pane>

                    <Tab.Pane eventKey="third">
                    <Row>
                      {
                          premiumPacksLinks.map((premiumPacksLink, index) => {
                            return (
                              <ProductCardB
                                key={index}
                                {...premiumPacksLink}
                                />
                            )
                          })
                        } 
                    </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt=''></img>
    </section>
  )
}
